import React, { useState } from "react";

const services = {
  "Dental Check Ups":
    "Routine oral exams to prevent cavities and gum disease early.",
  Fillings: "Restore damaged teeth using durable, natural-looking materials.",
  "Scaling & Polishing": "Deep cleaning to remove plaque, tartar, and stains.",
  "Root Canals": "Pain-free treatment to save infected teeth.",
  "Dental Implants": "Permanent tooth replacement solution.",
  "Teeth Whitening": "Brighten your smile safely and effectively.",

  "Tooth Extraction": "Safe and gentle removal of damaged or infected teeth.",
  "Partial Dentures":
    "Replace missing teeth while keeping natural ones intact.",
  Dentures: "Complete tooth replacement for a confident smile.",
  Crowns: "Strong protective caps to restore damaged teeth.",
  Bridges: "Fill gaps using natural-looking fixed teeth replacements.",
  "Installing Braces": "Straighten teeth for perfect alignment and bite.",
  "Tooth Jewellery": "Cosmetic tooth accessories for a stylish smile.",
  "Children Dentistry": "Special gentle care for kids’ dental health.",
  "Preventive Treatment": "Early care to avoid future dental problems.",
};

export default function App() {
  const [selected, setSelected] = useState<any>(null);

  return (
    <div style={{ fontFamily: "Segoe UI, Arial", background: "#f4fbff" }}>
      {/* HEADER */}
      <div
        style={{
          background: "white",
          padding: "40px 20px",
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,.1)",
        }}
      >
        <img
          src="/logo.png"
          alt="AK Dentistry Logo"
          style={{ width: "160px", marginBottom: "15px" }}
        />

        <h1 style={{ color: "#0a5ea8" }}>Dr Amer Khan Dental Care</h1>
        <p style={{ color: "#555", fontSize: "18px" }}>
          Your smile deserves expert care
        </p>
      </div>

      {/* SERVICES */}
      <div
        style={{ maxWidth: "1100px", margin: "60px auto", padding: "0 20px" }}
      >
        <h2 style={{ textAlign: "center", color: "#0a5ea8" }}>Our Services</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "24px",
            marginTop: "30px",
          }}
        >
          {Object.keys(services).map((service) => (
            <div
              key={service}
              onClick={() => setSelected(service)}
              style={{
                background: "white",
                padding: "28px",
                borderRadius: "18px",
                boxShadow: "0 8px 18px rgba(0,0,0,.12)",
                cursor: "pointer",
                textAlign: "center",
                transition: "0.3s",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <div style={{ fontSize: "46px" }}>🦷</div>
              <h3>{service}</h3>
              <p style={{ color: "#666" }}>Click to learn more</p>
            </div>
          ))}
        </div>
      </div>

      {/* POPUP */}
      {selected && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "35px",
              borderRadius: "14px",
              maxWidth: "400px",
              textAlign: "center",
            }}
          >
            <h2 style={{ color: "#0a5ea8" }}>{selected}</h2>
            <p>{services[selected as keyof typeof services]}</p>

            <a
              href={`https://wa.me/923055941491?text=I want appointment for ${selected}`}
              target="_blank"
              rel="noreferrer"
              style={{
                display: "inline-block",
                background: "#0a5ea8",
                color: "white",
                padding: "12px 26px",
                borderRadius: "8px",
                textDecoration: "none",
                marginTop: "15px",
              }}
            >
              Book Appointment
            </a>

            <div>
              <button
                onClick={() => setSelected(null)}
                style={{ marginTop: "12px" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <div
        style={{
          background: "#0a5ea8",
          color: "white",
          textAlign: "center",
          padding: "28px",
          marginTop: "60px",
        }}
      >
        <p>📍 Mall of KP, Tehkal, Peshawar</p>
        <p>📞 +92 305 5941491</p>
        <p>✉️ amerkhan756@gmail.com</p>
      </div>
    </div>
  );
}
